import { TooltipProps, Typography } from 'antd';
import { EllipsisConfig } from 'antd/es/typography/Base';
import { ParagraphProps } from 'antd/es/typography/Paragraph';
import { ReactNode, useState } from 'react';

type Props = Omit<ParagraphProps, 'ellipsis'> & {
    ellipsis?: Omit<EllipsisConfig, 'tooltip'> & { tooltip?: TooltipProps };
    message?: boolean;
    tooltip?: ReactNode;
};
export default function ParagraphWithTooltip({
    children,
    message,
    ellipsis = {},
    style = {},
    tooltip,
    ...props
}: Props) {
    const [truncated, setTruncated] = useState(false);

    return (
        <Typography.Paragraph
            {...props}
            ellipsis={{
                ...(message ? { rows: 2 } : {}),
                tooltip: {
                    title: truncated ? tooltip || children : undefined,
                    overlayInnerStyle: { maxHeight: 250, overflowY: 'auto' },
                    ...(ellipsis?.tooltip ?? {})
                },
                ...ellipsis,
                onEllipsis: setTruncated
            }}
            style={{ margin: 0, ...style }}
        >
            <>{children}</>
        </Typography.Paragraph>
    );
}
